/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAutoValidatedOrdersQueryVariables = Exact<{
  buyerCompanyId: string;
  supplierCompanyId: string;
}>;


export type GetAutoValidatedOrdersQuery = { order: Array<{ total_price_to_pay_excl_tax: number | null }> };


export const GetAutoValidatedOrdersDocument = /*#__PURE__*/ gql`
    query GetAutoValidatedOrders($buyerCompanyId: uuid!, $supplierCompanyId: uuid!) {
  order(
    where: {contract: {buyingCompanyId: {_eq: $buyerCompanyId}, supplyingCompanyId: {_eq: $supplierCompanyId}}, is_auto_validated: {_eq: true}}
  ) {
    total_price_to_pay_excl_tax
  }
}
    `;

/**
 * __useGetAutoValidatedOrdersQuery__
 *
 * To run a query within a React component, call `useGetAutoValidatedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAutoValidatedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAutoValidatedOrdersQuery({
 *   variables: {
 *      buyerCompanyId: // value for 'buyerCompanyId'
 *      supplierCompanyId: // value for 'supplierCompanyId'
 *   },
 * });
 */
export function useGetAutoValidatedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables> & ({ variables: GetAutoValidatedOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>(GetAutoValidatedOrdersDocument, options);
      }
export function useGetAutoValidatedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>(GetAutoValidatedOrdersDocument, options);
        }
// @ts-ignore
export function useGetAutoValidatedOrdersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>;
export function useGetAutoValidatedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAutoValidatedOrdersQuery | undefined, GetAutoValidatedOrdersQueryVariables>;
export function useGetAutoValidatedOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>(GetAutoValidatedOrdersDocument, options);
        }
export type GetAutoValidatedOrdersQueryHookResult = ReturnType<typeof useGetAutoValidatedOrdersQuery>;
export type GetAutoValidatedOrdersLazyQueryHookResult = ReturnType<typeof useGetAutoValidatedOrdersLazyQuery>;
export type GetAutoValidatedOrdersSuspenseQueryHookResult = ReturnType<typeof useGetAutoValidatedOrdersSuspenseQuery>;
export type GetAutoValidatedOrdersQueryResult = Apollo.QueryResult<GetAutoValidatedOrdersQuery, GetAutoValidatedOrdersQueryVariables>;